"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
var Tabs = __importStar(require("./Tabs"));
var Form = function (_a) {
    var user = _a.user, video = _a.video, setVideo = _a.setVideo, livestream = _a.livestream, setLivestream = _a.setLivestream, channel = _a.channel, toggleVideoOption = _a.toggleVideoOption, submit = _a.submit;
    var tabItems = [
        {
            name: 'Video',
            label: 'Video',
            save: true,
        },
        {
            name: 'Match',
            label: 'Wedstrijd',
            save: true,
        },
        {
            name: 'Paid',
            label: 'Betaald',
            save: true,
        },
    ];
    if (video.id) {
        tabItems.push({
            name: 'Share',
            label: 'Delen',
            save: false,
        });
    }
    if (livestream.data.id) {
        tabItems.push({
            name: 'Schedule',
            label: 'Schedule',
        });
    }
    if (user.is_admin) {
        tabItems.push({
            name: 'Manual',
            label: 'Handmatig',
            save: true,
        });
    }
    var _b = react_1.useState(tabItems[0]), activeTab = _b[0], setActiveTab = _b[1];
    var ActiveTab = Tabs[activeTab.name];
    return react_1.default.createElement(storybook_1.Cards.Card, { type: 'group' },
        react_1.default.createElement(storybook_1.Cards.Content, null,
            react_1.default.createElement(storybook_1.Menus.Dashboard.Tabs, { appendClassname: 'flex flex-col', activeTab: activeTab.name, setActiveTab: function (name) { return setActiveTab(tabItems.findBy('name', name)); }, items: tabItems }),
            react_1.default.createElement(ActiveTab, { video: video, setVideo: setVideo, livestream: livestream.data, setLivestream: setLivestream, channel: channel, toggleVideoOption: toggleVideoOption }),
            activeTab.save &&
                react_1.default.createElement(storybook_1.Forms.Buttons, { loading: livestream.submitting, errors: livestream.errors, submit: submit })));
};
exports.Form = Form;
